import * as types from './types';

export const setValue = payload => ({
  type: types.SET_VALUE,
  payload,
});

export const getValue = payload => ({
  type: types.GET_VALUE,
  payload,
});
